<template lang="pug">
#visualizar-contrato-originacao
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtituloVisualizar")',
        :voltarPara='true',
        :exibeBotao='false'
    )
    section.visualizar-contrato-originacao__body
        .visualizar-contrato-originacao__card
            h1 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtitulo') }}
            card
                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.numeroContrato') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.numeroContrato }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.corredor') }}
                        span.data-value
                            | {{ this.payload?.sucursal?.nome ? this.payload?.sucursal?.nome + ' - ' : '' }}{{ this.payload.dadosContratoOriginacao.fornecedorParceiroNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.vendedor') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.nomeVendedor }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.produto') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.materialNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.anoAfip') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.safraNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataContrato') }}
                        span.data-value
                            | {{ this.formatarData(this.payload.dadosContratoOriginacao.dataContrato) }}
                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataEntrega') }}
                        span.data-value
                            | {{ this.formatarData(this.payload.dadosContratoOriginacao.dataPrevistaEntrega) }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.cuitVendedor') }}
                        span.data-value
                            | {{ this.formatarCuit(this.payload.dadosContratoOriginacao.cuitVendedor) }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.condicaoClienteLabel') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.condicaoCliente }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.provincia') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.localidadeNivelUmNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.departamento') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.localidadeNivelDoisNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.origem') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.localidadeNivelTresNome }}
                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.estrutura') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.estructuraComercial }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.volumeContratado') }} (t)
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.volumeContratado }}
                    //- .col-2.data-display
                    //-     span.data-title
                    //-         | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.idPlantaEntregaBunge') }}
                    //-     span.data-value
                    //-         | {{ this.payload.dadosContratoOriginacao.plantaEntregaBungeId }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.condicaoFrete') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.condicaoFrete }}

            section.visualizar-contrato-originacao__territorio_resumo(
                v-if='mostrarDadosVolumeTerritorio()'
            )
                h2.mt-4.mb-4 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumePorTerritorio') }}
                    section.d-flex.mb-4
                        .visualizar-contrato-originacao__card__territorios
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMaximoPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMaximoTerritorio }} (t)

                        .visualizar-contrato-originacao__card__territorios.mr-4.ml-4
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMedioPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMedioTerritorio }} (t)

                        .visualizar-contrato-originacao__card__territorios(
                            style='padding-right: 13px'
                        )
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMinimoPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMinimoTerritorio }} (t)

                    section
                        .visualizar-contrato-originacao__resumo-total.d-flex
                            section(style='width: 50%')
                                .div.table-header.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.resumo') }}
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.total') }}
                                .div.table-column.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeContratado') }}
                                    span {{ payload.resumo.volumeContratado }}
                                .div.table-column.table-column-active.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeConforme') }}
                                    span {{ payload.resumo.volumeConforme }}
                                .div.table-column.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeAlerta') }}
                                    span {{ payload.resumo.volumeComAlertas }}
                                .div.table-column.table-column-active.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeEntregue') }}
                                    span {{ payload.resumo.volumeEntregue }}

                            section(style='width: 50%')
                                .div.table-header
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.resumo') }}
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.total') }}
                                .div.table-column
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritorios') }}
                                    span {{ payload.resumo.territoriosInseridos }}
                                .div.table-column.table-column-active
                                    div
                                        i.mr-2.mt-2.flow.flow-verified.verde.custon-icon
                                        span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritoriosConforme') }}
                                    span {{ payload.resumo.territoriosConforme }}
                                .div.table-column
                                    div
                                        i.mr-2.mt-2.flow.flow-warning-sign.custon-icon
                                        span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritoriosAlerta') }}
                                    span {{ payload.resumo.territoriosComAlertas }}
                                .div.table-column.table-column-active
            TabelaTerritoriosInseridosRevenda(
                v-if='this.payload.dadosContratoOriginacao.materialCodigo !== "SOJA_COMUM_AR" && this.payload.dadosContratoOriginacao.statusEmpresaCodigo === "CONCLUIDO"',
                ref='tabelaTerritorioAr',
                :territorios='territorios',
                :carregando='loadingTerritorios',
                :paginacao='paginacao',
                @mudarPagina='mudarPagina',
                @visualizarAnaliseElegibilidade='visualizarAnaliseElegibilidadeAr'
            )
            ModalAnaliseElegibilidadeResumoAr(
                :show='ativarModalAnaliseElegibilidade',
                :dados='dadosAnaliseElegibilidade',
                @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import Card from '@/components/Card';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import { mascaraRenspa } from '@/utils/masks/renspa.js';
import ModalAnaliseElegibilidadeResumoAr from '@/components/contratosOriginacao/ModalAnaliseElegibilidadeResumoAr.vue';
import TabelaSolicitacaoAnaliseCAR from '@/components/contratosOriginacao/EmpresaTabelaSolicitacaoAnaliseCar';
import TabelaTerritoriosInseridosRevenda from '@/components/contratosOriginacao/TabelaTerritoriosInseridosRevenda';
import formatters from '@/utils/formatters';
import { mapGetters } from 'vuex';

export default {
    name: 'VisualizarContratoOriginacaoEmpresa',
    components: {
        Card,
        ModalAnaliseElegibilidadeResumoAr,
        BaseHeader,
        TabelaSolicitacaoAnaliseCAR,
        TabelaTerritoriosInseridosRevenda
    },
    data: () => ({
        payload: {
            sucursal: {
                id: '',
                nome: ''
            },
            dadosContratoOriginacao: {
                numeroContrato: '',
                produto: '',
                anoAfip: '',
                volumeContratado: '',
                provincia: '',
                vendedor: '',
                cuitVendedor: '',
                status: ''
            },
            volumeTerritorios: {
                volumeMinimoTerritorio: '',
                volumeMedioTerritorio: '',
                volumeMaximoTerritorio: ''
            },
            resumo: {
                volumeContratado: '',
                volumeEntregue: '',
                volumeComAlertas: '',
                volumeConforme: '',
                territoriosComAlertas: '',
                territoriosConforme: '',
                territoriosInseridos: ''
            }
        },
        ativarModalAnaliseElegibilidade: false,
        dadosAnaliseElegibilidade: {},
        loadingResumo: {
            loadingRaio: false,
            loadingSaldo: false,
            analiseElegibilidade: false
        },
        territorios: [],
        loadingTerritorios: false,
        paginacao: {
            total: null,
            pagina: 0,
            itensPorPagina: 10
        }
    }),
    computed: {
        ...mapGetters(['isAlvorada'])
    },
    mounted() {
        this.buscarDados();
        this.buscarTerritorios(0);
    },
    methods: {
        async buscarDados() {
            await ContratoOriginacaoServiceEmpresa.buscarContratoOriginacaoAR(
                this.$route.params.id
            )
                .then(({ data }) => {
                    this.payload = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({ path: '/rastreabilidade/empresa' });
                });
        },

        async buscarTerritorios(pagina) {
            this.loadingTerritorios = true;
            this.paginacao.pagina = pagina;
            const response =
                await ContratoOriginacaoServiceEmpresa.buscarTerritoriosPreencherContratoAR(
                    {
                        contrato: this.$route.params.id,
                        pagina: this.paginacao.pagina,
                        tamanho: this.paginacao.itensPorPagina
                    }
                );

            const responseData = response.data;
            const dataRenspaFormatado = responseData.itens.map(item => ({
                ...item,
                cuit: this.alterarMascara(
                    item.territorioRepresentantes[0].cpfCnpj
                ),
                renspaTerritorio: mascaraRenspa(item.renspaTerritorio)
            }));

            this.territorios = dataRenspaFormatado;

            this.paginacao = { ...response.paginacao };
            this.paginacao.pagina += 1;
            this.loadingTerritorios = false;
        },

        alterarMascara(cpf) {
            if (!cpf) return;
            const somenteNumeros = cpf.replace(/\D/g, '');
            const novaMascara = somenteNumeros.replace(
                /^(\d{2})(\d{8})(\d)$/,
                '$1-$2-$3'
            );

            return novaMascara;
        },

        mudarPagina(novaPagina) {
            this.buscarTerritorios(novaPagina);
        },

        async visualizarAnaliseElegibilidadeAr(row) {
            try {
                const numeroContrato = this.$route.params.id;
                const idTerritorio = row.idTerritorio;
                // Usar endpoint consolidado em vez dos endpoints antigos
                const { data } = await ContratoOriginacaoServiceSubEmpresa.buscarResumoAnaliseElegibilidadePreInsercaoTerritorioAr({
                    idRepresentante: 0,
                    idTerritorio: idTerritorio,
                    numeroContrato: numeroContrato,
                    isSucursal: false,
                    idDadosContratoOriginacao: row.id
                });

                // Mapear dados para estrutura unificada
                this.dadosAnaliseElegibilidade.dadosDiagnostico = data.diagnosticoSocioambiental;
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = data.raioTerritorio;
                this.dadosAnaliseElegibilidade.elegibilidade = data.resultadoResumoAnaliseElegibilidadePreInsercaoTerritorioSubempresa;
                this.dadosAnaliseElegibilidade.saldoTerritorial = data.diagnosticoSaldoTerritorial;
                this.dadosAnaliseElegibilidade.territorioOutput = data.territorioOutput;
                this.dadosAnaliseElegibilidade.certificacao = data.certificacao;

                this.ativarModalAnaliseElegibilidade = true;
            } catch (e) {
                if (
                    e.response?.data?.message ===
                    'rendimento.provinciaEDepartamentoNaoEncontrado'
                ) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.erroRendimento'
                        )
                    });
                    return;
                }

                this.$notify.error({
                    message: e.response?.data?.message
                });
            }
        },

        formatarCuit(cuit) {
            return formatters.formatarCuit(cuit);
        },

        formatarData(dataISO) {
            const data = new Date(dataISO);
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            return `${dia}/${mes}/${ano}`;
        },

        mostrarDadosVolumeTerritorio() {
            return this.payload.resumo && this.payload.volumeTerritorios;
        },

        getStatusTraduzido(status) {
            switch (status) {
                case 'NAO_ENVIADO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoNaoEnviado'
                    );
                case 'NAO_VISUALIZADO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosNaoVisualizado'
                    );
                case 'VISUALIZADO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosVisualizado'
                    );
                case 'EM_CADASTRAMENTO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosEmCadastramento'
                    );
                case 'CONCLUIDO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosConcluido'
                    );
                case 'ARQUIVADO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosArquivado'
                    );
                default:
                    return '';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#visualizar-contrato-originacao {
    .visualizar-contrato-originacao__body {
        padding: 20px 33px 20px 20px;
        overflow-y: auto;
    }

    .visualizar-contrato-originacao__card {
        gap: 10px;
        display: grid;
        h1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 19px;
            margin-top: 15px;
        }
        .button-edicao-contrato {
            display: flex;
            justify-content: flex-end;
        }
    }

    .visualizar-contrato-originacao__territorio_resumo {
        h2.mt-4.mb-4 {
            font-size: 16px;
            font-weight: bold;
        }
    }
    .visualizar-contrato-originacao__card__territorios {
        height: 80px;
        width: 100%;
        padding: 20px;
        border-radius: $default-border-radius;
        background: white;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--primary);
    }

    .d-flex.mb-4 {
        margin-top: 15px;
    }
    .visualizar-contrato-originacao__resumo-total {
        width: 100%;
        background: white;
        border-radius: $default-border-radius;
    }

    .table-header {
        color: var(--primary);
        font-weight: 600;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        padding: 15px 20px;
        border-bottom: solid 1px #a1a1a1ff;
    }

    .table-column {
        padding: 15px 20px;
        height: 50px;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
    }

    .table-column-active {
        background: #ecececcf;
    }

    .table-border {
        border-right: solid 1px #a1a1a1ff;
    }

    .data-display {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;

        .data-title {
            font-size: 14px;
            margin-bottom: 8px;
            color: var(--primary);
            font-weight: 600;
        }

        .data-value {
            font-size: 14px;
            color: #636363;
        }
    }

    .mr-2.mt-2.flow.flow-warning-sign.custon-icon {
        color: var(--warning);
    }

    .visualizar-alerta {
        padding-bottom: 20px;
    }
}
</style>
